import { render, staticRenderFns } from "./change_phone.vue?vue&type=template&id=6cda8316&scoped=true&"
import script from "./change_phone.vue?vue&type=script&lang=js&"
export * from "./change_phone.vue?vue&type=script&lang=js&"
import style0 from "./change_phone.vue?vue&type=style&index=0&id=6cda8316&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cda8316",
  null
  
)

export default component.exports